<template>
  <b-row>
    <b-col>
      <div class="club-group">
        <div
          v-for="quant in Object.keys(quantities)"
          :key="quant"
          :class="{selected: selectedOrderQuantityComputed === quant}"
          class="club-card"
          @click="selectedOrderQuantityComputed = quant"
        >
          <div class="club-card-inner">
            <div class="graphic">
              <div
                :style="{backgroundImage: `url(${quantityImage})`}"
                class="image"
              />
            </div>
            <div class="club-card-content">
              <div class="title">
                <h3>{{ quantity(quant) }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import StepHeader from './StepHeader'
import quantityImage from '../../assets/quantity.svg'

export default {
  name: 'quantity-step',
  components: {
    StepHeader
  },
  computed: {
    quantityImage: function() {
      return quantityImage
    },
    selectedOrderQuantityComputed: {
      get() {
        return this.selectedQuantity
      },
      set(val) {
        this.SET_SELECTED_QUANTITY(val)
        this.updateSelectedOrderOtherClub()
        this.updatePreselectedProducts()
      }
    },
    quantities() {
      return this.getQuantities(this.selectedOrderType, this.selectedFrequency)
    },
    ...mapState('somnambulistui', ['siteSettings', 'selectedOrderType', 'selectedFrequency', 'selectedQuantity']),
    ...mapGetters('somnambulistui', ['getQuantities'])
  },
  methods: {
    ...mapMutations('somnambulistui', ['SET_SELECTED_QUANTITY']),
    ...mapActions('somnambulistui', ['updatePreselectedProducts', 'updateSelectedOrderOtherClub']),
    quantity(val) {
      return this.$store.getters['somnambulistui/quantity'](val)
    },
    formatedHtml(escapedHtml) {
      return escapedHtml.replace(/&lt;/g, '<').replace(/&gt;/g, '>')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

</style>
